import PropTypes from "prop-types";

export const fullScheduleComponentProps = PropTypes.arrayOf(
    PropTypes.shape({
        showTitle: PropTypes.string.isRequired,
        startTime: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(Date),
        ]).isRequired,
        guests: PropTypes.arrayOf(
            PropTypes.shape({
                guestName: PropTypes.string.isRequired,
                guestStartTime: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.instanceOf(Date),
                ]),
                guestTitle: PropTypes.string,
                guestCompanyName: PropTypes.string,
            })
        ),
        showDescription: PropTypes.string,
    })
);
